import { render } from "./investmentAccount.vue?vue&type=template&id=2b5ec5a8&scoped=true"
import script from "./investmentAccount.vue?vue&type=script&lang=js"
export * from "./investmentAccount.vue?vue&type=script&lang=js"

import "./investmentAccount.vue?vue&type=style&index=0&id=2b5ec5a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5ec5a8"]])

export default __exports__